module.exports = __webpack_public_path__ + "assets/map.45ef879162a53e2df47f9841162a4e71.svg";


//////////////////
// WEBPACK FOOTER
// ../static/images/map.svg
// module id = 434
// module chunks = 0